import { z } from 'zod';
/** Studio roles, held per membership. creator is confined to the upload page. */
export const StudioRole = z.enum(['creator', 'reviewer', 'editor', 'owner']);
export const ROLE_RANK = { creator: 0, reviewer: 1, editor: 2, owner: 3 };
export function roleAtLeast(role, minimum) {
    return ROLE_RANK[role] >= ROLE_RANK[minimum];
}
/** Which sidebar sections each role may see. Routes are filtered against this at the router level. */
export const ROLE_SECTIONS = {
    creator: ['creator-upload'],
    reviewer: ['approve', 'scheduled', 'published', 'voice'],
    editor: ['upload', 'analyse', 'tagging', 'browse', 'collections', 'library', 'usage', 'queue', 'compose', 'compose-fast', 'archive', 'audio', 'exports', 'approve', 'scheduled', 'published', 'voice'],
    owner: ['upload', 'analyse', 'tagging', 'browse', 'collections', 'library', 'usage', 'queue', 'compose', 'compose-fast', 'archive', 'audio', 'exports', 'approve', 'scheduled', 'published', 'voice', 'settings'],
};
//# sourceMappingURL=roles.js.map